import { FlexContainer, Buttons, Text, Banner } from '@taxdown/piccolo-web';
import { locizeNS } from 'Services/i18n';
import { useTranslation } from 'Hooks/useTranslation';
import { useFetchGetUserClabe } from 'Containers/Account/components/AccountProfile/hooks';
import ResultDetailCompensation from 'Containers/Dashboard/components/TaxScreen/components/ResultDetailCompensation';
import SaveClabeBanner from 'Components/SaveClabeBanner';
import ConfirmClabeBanner from 'Components/ConfirmClabeBanner';
import { FiledScreenProps, ResultTypes } from 'Types/common';
import ResultInfo from '../ResultInfo';
import { addDaysToDate } from '../utils';
import * as Styled from './Styles';
import { lottieDictionary } from './utils';

const View = ({ tax, handleShowDraft }: FiledScreenProps): JSX.Element => {
  const { t } = useTranslation(locizeNS.DASHBOARD);
  const { data } = useFetchGetUserClabe();
  const { taxYear, pdf, filingInfo, taxReturnResult } = tax;
  const lottieToRender = lottieDictionary[taxReturnResult?.taxReturnType || ResultTypes.toPay];
  const isCompensation = data?.payWithExternalService;

  const installmenstContext =
    data?.installmentsListSelected &&
    data?.installmentsListSelected?.length > 3 &&
    'installmentsInfo';

  return (
    <FlexContainer direction="column" fullHeight fullWidth gap="dimension_16">
      <SaveClabeBanner />
      {taxReturnResult?.mandatory && (
        <Banner
          id="congratulations-banner"
          label={
            filingInfo?.recent?.taxReturnType
              ? t(`Congratulations.Chip.${filingInfo?.recent?.taxReturnType}`)
              : t(`Congratulations.Chip.message`)
          }
          mode="success"
          layout="embed"
        />
      )}
      <Styled.InfoContainer
        justify="center"
        direction="column"
        align="center"
        fullWidth
        fullHeight
        gap="dimension_08"
      >
        <Text size="L_L_S" color="dark" type="headline">
          {taxYear}
        </Text>
        <Text type="paragraphs" size="L_L_M" color="dark" align="center">
          {t(`Dashboard.Filed.message.${filingInfo?.recent?.taxReturnType}`)}
        </Text>
        <Styled.StyledLottie
          options={{
            path: lottieToRender,
            rendererSetting: { progressiveLoad: true },
          }}
        />
        {isCompensation ? (
          <ResultDetailCompensation filingInfo={filingInfo} taxReturnResult={taxReturnResult} />
        ) : (
          filingInfo && <ResultInfo filingInfo={filingInfo} />
        )}
        {filingInfo?.recent?.taxReturnType && (
          <Text type="paragraphs" color="dark" size="M_L_S" align="center">
            {t(`Filed.title.${filingInfo.recent.taxReturnType}`, {
              context: installmenstContext,
            })}
          </Text>
        )}
        {filingInfo?.recent?.taxReturnType !== ResultTypes.equal && (
          <Text type="paragraphs" color="dark" size="S_S_S" align="center">
            {t(`Filed.description.${filingInfo?.recent?.taxReturnType}`, {
              context: 'notIsZero',
              date: addDaysToDate(filingInfo?.recent?.filedAt, 40),
            })}
          </Text>
        )}
        <FlexContainer direction="column" align="center" gap="dimension_16">
          <Styled.ButtonsWrapper gap="dimension_16">
            {pdf && (
              <Buttons.Classic
                size="m"
                mode="primary"
                onClick={() => handleShowDraft(pdf)}
                label={t('Dashboard.Submitted.firstButton')}
              />
            )}
          </Styled.ButtonsWrapper>
          <ConfirmClabeBanner />
        </FlexContainer>
      </Styled.InfoContainer>
    </FlexContainer>
  );
};

export default View;
